// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__yh2kS","area-disclaimer":"style_area-disclaimer__U8Xcq","courtesy":"style_courtesy__Vq3fY","disclaimer":"style_disclaimer__fvcN2"};